import { MouseEventHandler } from 'react';

import clsx from 'clsx';

import Button from './Button';
import IconRubbishBin from './icons/IconRubbishBin';
import IconSmallCheck from './icons/IconSmallCheck';

interface FormActionsProps {
  onSubmit: MouseEventHandler<HTMLButtonElement>;
  onCancel: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const FormActions = ({ onSubmit, onCancel, className }: FormActionsProps) => {
  return (
    <div className={clsx('absolute z-10 flex space-x-[9px] py-2', className)}>
      <Button type="pill" className="shadow-button-regular" onClick={onSubmit}>
        <IconSmallCheck className="fill-brand-gray-100" />
      </Button>
      <Button type="pill" className="shadow-button-regular" onClick={onCancel}>
        <IconRubbishBin className="fill-brand-gray-100" />
      </Button>
    </div>
  );
};

export default FormActions;
